/* Wrapper for Google maps behavior that will automatically load the script
 * if it hasn't been loaded already.
 */
import Rover from '@rover/globals/Rover';

class Maps {
  constructor() {
    this.onMapLoadedCallbacks = [];
    this.LoadingStatus = {
      UNLOADED: 'unloaded',
      LOADING: 'loading',
      LOADED: 'loaded',
    };
    this.loadStatus = this.LoadingStatus.UNLOADED;
    this.geocoder = null;
    this.autocompleteService = null;
    this.mapIsLoaded = false;
    this.mapLoading = false;
  }

  onMapLoaded() {
    this.geocoder = new google.maps.Geocoder();
    this.autocompleteService = new google.maps.places.AutocompleteService();
    this.loadStatus = this.LoadingStatus.LOADED;
    let callback;
    while (true) {
      callback = this.onMapLoadedCallbacks.pop();
      if (!callback) {
        break;
      }
      callback();
    }
  }

  loadMaps() {
    if (this.loadStatus !== this.LoadingStatus.UNLOADED) return;
    this.loadStatus = this.LoadingStatus.LOADING;
    const script = document.createElement('script');
    script.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(script);
    script.async = true;
    script.src = `https://maps.googleapis.com/maps/api/js?client=${
      Rover.settings.googleMapsClientId
    }&libraries=places&v=3&callback=window.globalState.maps.onMapLoaded`;
  }

  addHandler(handler) {
    if (this.loadStatus === this.LoadingStatus.LOADED) {
      handler();
    } else {
      this.onMapLoadedCallbacks.push(handler);
    }
    this.loadMaps();
  }

  geocode(data, callback) {
    const handler = () => {
      this.geocoder.geocode(data, callback);
    };
    this.addHandler(handler);
  }

  getPlacePredictions(data, callback) {
    const handler = () => {
      this.autocompleteService.getPlacePredictions(data, callback);
    };
    this.addHandler(handler);
  }
}

window.globalState = window.globalState || {};
window.globalState.maps = window.globalState.maps || new Maps();

export default window.globalState.maps;



// WEBPACK FOOTER //
// ./js/components/maps.js